import { useState } from "react";
import axios from "axios";
import { ChevronDown, ExternalLink, Instagram, Link2, Unlink } from "lucide-react";
import { toast } from "sonner";
import { ACCOUNT, API, errText } from "@/components/instagram/common";

const STEPS = [
  <><a href="https://developers.facebook.com/apps" target="_blank" rel="noreferrer">developers.facebook.com/apps</a> adresinde <b>Uygulama oluştur</b>'a basın. Kullanım alanı olarak <b>"Instagram'da mesajları ve içeriği yönet"</b>i, işletme portföyü olarak Emlak Sepeti'ni seçin.</>,
  <>Uygulamanın sol menüsünden <b>Kullanım alanları → Instagram → API kurulumu (Instagram girişiyle)</b> sayfasını açın.</>,
  <><b>Erişim anahtarı oluştur</b> bölümünde <b>Hesap ekle</b>'ye basıp Instagram hesabınızla giriş yapın ve izin verin.</>,
  <>Hesabınızın yanındaki <b>Anahtar oluştur</b> butonuna basın, çıkan uzun anahtarı kopyalayıp aşağıya yapıştırın.</>,
];

function Guide() {
  const [open, setOpen] = useState(false);
  return (
    <div className="ig-guide">
      <button type="button" className="text-btn" onClick={() => setOpen(!open)} data-testid="ig-guide-toggle"><ChevronDown size={13} className={`nav-chev${open ? " open" : ""}`} />Erişim anahtarını nasıl alırım? (5 dakika)</button>
      {open && <ol data-testid="ig-guide-steps">{STEPS.map((s, i) => <li key={i}>{s}</li>)}</ol>}
      {open && <small className="form-hint">Uygulamayı "Yayında" moduna almanız gerekmez; kendi hesabınız için geliştirme modunda çalışır. Anahtar uygulama tarafından otomatik yenilenir.</small>}
    </div>
  );
}

function TokenForm({ onChanged }) {
  const [token, setToken] = useState(""), [busy, setBusy] = useState(false);
  const connect = async (e) => {
    e.preventDefault(); setBusy(true);
    try { const r = await axios.post(`${API}/instagram/connect`, { token }); setToken(""); toast.success(`@${r.data.username} bağlandı`); onChanged(r.data); }
    catch (err) { toast.error(errText(err)); }
    setBusy(false);
  };
  return (
    <form className="ig-token" onSubmit={connect}>
      <input type="password" required minLength={20} value={token} onChange={(e) => setToken(e.target.value)} placeholder="Instagram erişim anahtarını yapıştırın" autoComplete="off" data-testid="ig-token-input" />
      <button className="primary-btn" disabled={busy} data-testid="ig-connect-button"><Link2 size={15} />{busy ? "Kontrol ediliyor…" : "Bağla"}</button>
    </form>
  );
}

export function ConnectCard({ st, onChanged }) {
  if (!st) return <div className="panel ig-connect"><p className="empty">Bağlantı kontrol ediliyor…</p></div>;
  const disconnect = async () => {
    if (!window.confirm("Instagram bağlantısı kaldırılsın mı? Zamanlanmış gönderiler yeniden bağlanana kadar paylaşılmaz.")) return;
    try { await axios.delete(`${API}/instagram/connect`); toast.success("Instagram bağlantısı kaldırıldı"); onChanged({ connected: false }); } catch (e) { toast.error(errText(e)); }
  };
  if (st.connected && !st.error) return (
    <div className="panel ig-connect connected" data-testid="ig-connected">
      {st.picture ? <img className="ig-avatar" src={st.picture} alt="" /> : <span className="ig-avatar"><Instagram size={20} /></span>}
      <div className="ig-connect-text"><b data-testid="ig-username">@{st.username}</b><small>{[st.name, ACCOUNT[st.account_type]].filter(Boolean).join(" · ")} · Bağlı, otomatik paylaşıma hazır</small></div>
      <a className="outline-btn" href={`https://instagram.com/${st.username}`} target="_blank" rel="noreferrer" data-testid="ig-open-profile"><ExternalLink size={14} />Profili aç</a>
      <button className="icon-btn danger" onClick={disconnect} title="Bağlantıyı kaldır" data-testid="ig-disconnect"><Unlink size={16} /></button>
    </div>
  );
  return (
    <div className="panel ig-connect" data-testid="ig-connect-card">
      <span className="ig-avatar"><Instagram size={20} /></span>
      <div className="ig-connect-text">
        <b>{st.error ? `@${st.username} bağlantısı yenilenmeli` : "Instagram hesabınızı bağlayın"}</b>
        <small data-testid="ig-connect-hint">{st.error || "İşletme veya içerik üreticisi hesabınızın erişim anahtarıyla bir kez bağlayın; post ve story'ler seçtiğiniz saatte otomatik paylaşılır."}</small>
        <TokenForm onChanged={onChanged} />
        <Guide />
      </div>
      {st.error && <button className="icon-btn danger" onClick={disconnect} title="Bağlantıyı kaldır" data-testid="ig-disconnect"><Unlink size={16} /></button>}
    </div>
  );
}
